import { useContext } from 'react';
import { useUniversalEffect } from '../useUniversalEffect';
import { FetchManagerContext } from './FetchManagerContext';
import { MfServerSideDataContext } from 'Common/providers/MfServerSideData';

const useGetServerSideAction = (mfName: string) => {
    const { setMfState, state } = useContext(MfServerSideDataContext);

    /**
     * @param executor In case of returning void - result would be ignored and no state update would happen.
     * That used to prevent additional calls of executor in consumers on client-side
     */
    const useUniversalFetch = <T>(actionName: string, executor: () => PromiseLike<T | void>, deps: any[]): void => {
        const connectedAction = async () => {
            try {
                const result = await executor();
                if (typeof result !== 'undefined') {
                    setMfState(mfName, actionName, result);
                }
            } catch (err) {
                setMfState(mfName, actionName, err);
            }
        };

        const fetchManager = useContext(FetchManagerContext);
        useUniversalEffect(() => {
            fetchManager.executeAsyncAction(connectedAction);
        }, deps);
    };

    return { useUniversalFetch, state: state?.[mfName] };
};

export default useGetServerSideAction;
